export const CHART_TYPES = [
  "table",
  "bar",
  "line",
  "pie",
  "donut",
  "histogram",
  "scatter",
  "area",
  "radar",
  "treemap",
  "funnel",
  "bubble",
  "waterfall",
  "heatmap",
];